import {
  useWSModalCustom,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { BulkActionReminder } from "../components/BulkActionReminder";
import { BulkActionType } from "../types";

type Props = {
  actionName: string;
  actionType: BulkActionType;
  itemCount: number;
} & WSModalCustomProps<"background" | undefined>;

const ModalBulkActionPreparing: React.FC<Props> = props => {
  const isForeground = props.actionType === "foreground";

  const handleMinimize = useCallback(() => {
    props.onClose("background");
  }, [props]);

  return (
    <WSModal
      title={props.actionName}
      onClose={() => props.onClose(undefined)}
      blockClose={isForeground}
      actions={
        !isForeground
          ? {
              alignment: "fill",
              buttons: [
                {
                  kind: "Secondary",
                  label: "Minimize",
                  onClick: handleMinimize,
                  type: "button"
                }
              ]
            }
          : undefined
      }
    >
      <WSList gap="M">
        <WSElement px="L">
          <WSList gap="L">
            <WSFlexBox.CenterY>
              <WSIcon name="loader" size="S" color="gray500" mr="S" />
              <WSText.ParagraphSm color="gray700">
                Preparing to {props.actionName.toLowerCase()} (
                {props.itemCount.toLocaleString()} items)
              </WSText.ParagraphSm>
            </WSFlexBox.CenterY>
          </WSList>
        </WSElement>

        <BulkActionReminder
          actionName={props.actionName}
          actionType={props.actionType}
        />
      </WSList>
    </WSModal>
  );
};

export const useModalBulkActionPreparing = () =>
  useWSModalCustom(ModalBulkActionPreparing);
